/**
 * The Appearance page's rows of the settings-search catalog, extracted from
 * `settingsSearch.ts` so that file stays within its size ratchet while the
 * page keeps growing rows. Same shape, same rules: the catalog stays the
 * single source of the rendered titles.
 *
 * @module
 */

export const APPEARANCE_SETTINGS_SEARCH_ROWS = [
  {
    id: "appearance-colour-scheme",
    title: "Colour scheme",
    to: "/settings/appearance",
    keywords: ["dark mode", "light mode", "color scheme", "system"],
  },
  { id: "appearance-theme", title: "Theme", to: "/settings/appearance", keywords: ["colours"] },
  {
    id: "appearance-theme-halves",
    title: "Per-appearance themes",
    to: "/settings/appearance",
    keywords: ["mix", "half", "light", "dark", "per appearance"],
  },
  {
    id: "appearance-custom-themes",
    title: "Custom themes",
    to: "/settings/appearance",
    keywords: [
      "import",
      "export",
      "theme file",
      "json",
      "editor",
      "edit theme",
      "customize",
      "create theme",
    ],
  },
  {
    id: "appearance-contrast",
    title: "Interface contrast",
    to: "/settings/appearance",
    keywords: ["contrast", "accessibility", "readability"],
  },
  {
    id: "appearance-glass-opacity",
    title: "Glass opacity",
    to: "/settings/appearance",
    keywords: ["transparency", "blur"],
  },
  {
    id: "appearance-sidebar-layout",
    title: "Sidebar layout",
    to: "/settings/appearance",
    keywords: ["rail", "collapse"],
  },
  {
    id: "appearance-composer-collapse-on-blur",
    title: "Collapse composer on blur",
    to: "/settings/appearance",
    keywords: ["collapse", "composer", "blur", "unfocus", "resting"],
  },
  {
    id: "appearance-sidebar-legacy",
    title: "Sidebar (legacy)",
    to: "/settings/appearance",
    keywords: ["sidebar", "legacy", "escape hatch", "v1", "project tree"],
  },
] as const;
